import { Client } from "@smash-sdk/core";
import { HttpRequest, SDKError, config } from "@smash-sdk/core";
import { errors } from "./errors";
export * from "./errors";
export * from "./types/ChangePassword/ChangePassword";
export * from "./types/CreateToken/CreateToken";
export * from "./types/ForgotPassword/ForgotPassword";
export * from "./types/GetSigninConfiguration/GetSigninConfiguration";
export * from "./types/ResetPassword/ResetPassword";
export * from "./types/SsoSignin/SsoSignin";
const endpoints = {
    global: "https://directory.fromsmash.co",
};
config.setHosts("directory", endpoints, false);
export class Directory extends Client {
    constructor(params = {}) {
        super({ service: "directory", ...params, type: "global", userAgent: "@smash-sdk/directory@2.0.0-alpha.2" });
        this.errors = errors;
    }
    changePassword(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/change",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        password: params["password"],
                        username: params["username"],
                        account: params["account"],
                        secret: params["secret"],
                        id: params["id"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ChangePasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createToken(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/token",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        username: params["username"],
                        password: params["password"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTokenError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    forgotPassword(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/forgot",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        username: params["username"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ForgotPasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getSigninConfiguration(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/signin/configuration/:username",
                    headers: {},
                    pathParameters: {
                        username: params["username"],
                    },
                    queryParameters: {
                        version: "11-2023",
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetSigninConfigurationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    resetPassword(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/reset",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        password: params["password"],
                        username: params["username"],
                        account: params["account"],
                        secret: params["secret"],
                        id: params["id"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ResetPasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    ssoSignin(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/sso/signin",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        username: params["username"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.SsoSigninError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
}
Directory.errors = errors;
